:host {
  display: inline;
  line-height: 0;
}

:host(.full-width) {
  width: 100%;
}

@include supportedColors();
@include supportedTypography();

.icon {
  font-family: var(--primary-icon-font);
  line-height: 1;
  position: relative;
}

.rounded {
  border-radius: 50%;
  display: inline-block;
  transform: translateY(1px);
  padding: 3px;

  &.rounded-big {
    padding: 6px;
  }

  &.rounded-border {
    border: 1px solid var(--border-color-param);
  }
}

.silver {
  svg * {
    stroke: var(--color-silver);
    fill: var(--color-silver);
  }
}

.bleached-silk {
  svg * {
    stroke: var(--color-livique-bleached-silk);
    fill: var(--color-livique-bleached-silk);
  }
}

.anthrazit {
  svg * {
    stroke: var(--color-livique-anthrazit);
    fill: var(--color-livique-anthrazit);
  }
}

.cherryade {
  svg * {
    stroke: var(--color-livique-cherryade);
    fill: var(--color-livique-cherryade);
  }
}

.green-seduction {
  svg * {
    stroke: var(--color-livique-green-seduction);
    fill: var(--color-livique-green-seduction);
  }
}

.c {
  svg * {
    stroke: var(--color-warning);
    fill: var(--color-warning);
  }
}

// Old color classes for compatibility
.icon--highlight-blue {
  color: var(--color-blue)
}

.icon--highlight-green {
  color: var(--color-livique-green-seduction)
}

.icon-account-balance:before {
  content: '\e871';
}

.icon-checkbox-01 {
  svg {
    width: 18px;
    height: 18px;
  }
}

.icon-plus {
  &:before {
    content: '\e802';
  }

  display: inline-block;
  transform: rotate(45deg);
}

.icon-map-01:before {
  content: '\e809';
}

.icon-globus-01-2:before,
.ss-globe:before {
  content: '\e810';
}

.icon-truck-01:before {
  content: '\e822';
}

.icon-pdf:before,
.ss-notebook:before {
  content: '\e852';
}

.icon-info:before {
  content: '\e83d';
}

.icon-list:before {
  content: '\E830';
}

.icon-heart:before {
  content: '\e800';
}

.icon-bags:before {
  content: '\e801';
}

.icon-closed-01:before {
  content: '\e802';
}

.icon-heart-02:before {
  content: '\e804';
}

.icon-pen-01:before {
  content: '\e805';
}

.icon-envelope-01:before {
  content: '\e806';
}

.icon-bath-duck:before {
  content: '\e807';
}

.icon-profile:before {
  content: '\e808';
}

.icon-profile-filled:before {
  content: '\e83e';
}

.icon-map-01:before,
.icon-location:before,
.ss-location:before {
  content: '\e809';
}

.icon-flower:before {
  content: '\e80a';
}

.icon-chevron-down:before {
  content: '\e80b';
}

.icon-chevron-right:before {
  content: '\e80c';
}

.icon-chevron-left:before {
  content: '\e80d';
}

.icon-globus-01:before {
  content: '\e80e';
}

.icon-facebook-01:before {
  content: '\e80f';
}

.icon-globus-01-2:before {
  content: '\e810';
}

.icon-bag-01:before {
  content: '\e811';
}

.icon-menu-bars:before {
  content: '\e813';
}

.icon-checkmark-01:before,
.icon-tick:before {
  content: '\e814';
}

.icon-instagram-01:before {
  content: '\e815';
}

.icon-lamp:before {
  content: '\e816';
}

.icon-sale-01:before {
  content: '\e818';
}

.icon-tv:before {
  content: '\e819';
}

.icon-cart:before {
  content: '\e81a';
}

.icon-cart-filled:before {
  content: '\e840';
}

.icon-refresh-01:before {
  content: '\e81b';
}

.icon-trashcan-01:before {
  content: '\e81c';
}

.icon-star-01:before {
  content: '\e81e';
}

.icon-badge-check-01:before,
.ss-info:before {
  content: '\e81f';
}

.icon-couch:before {
  content: '\e820';
}

.icon-kids:before {
  content: '\e821';
}

.icon-truck-01:before,
.delivery-conditions-2__icon:before {
  content: '\e822';
}

.icon-fork-knife:before {
  content: '\e823';
}

.icon-bed:before {
  content: '\e824';
}

.icon-search:before {
  content: '\e825';
}

.icon-chevron-up:before {
  content: '\e84c';
}

.icon-star-02:before {
  content: '\e84d';
}

.icon-sale-02:before {
  content: '\e84e';
}

.icon-filter-by:before {
  content: '\e84f';
}

.icon-sort-by:before {
  content: '\e850';
}

.icon-zoom:before {
  content: '\e851';
}

.icon-pdf:before {
  content: '\e852';
}

.icon-eye-show:before {
  content: '\e82d';
}

.icon-eye-close:before {
  content: '\e82e';
}

.icon-house:before {
  content: '\e82f';
}

.icon-whatsapp:before {
  content: '\f232';
}

.icon-telegram:before {
  content: '\f2c6';
}

.icon-industry:before {
  content: '\f275';
}

.icon-info:before {
  content: '\e83d';
}

//.icon-supercard:before {
//  content: '\e897';
//}

.icon-supercard:before {
  content: '\e8b3';
}

.icon-supercard-2:before {
  content: '\e870';
}

.icon-check-mark02:before {
  content: '\e831';
}

.icon-padlock:before {
  content: '\e832';
}

.icon-warranty-extension:before {
  content: '\e869';
}

.icon-assembling:before {
  content: '\e86A';
}

.icon-pick-up:before {
  content: '\e86B';
}

.icon-loop:before {
  content: '\e827';
}


.icon-docs:before {
  content: '\f0c5';
}

.icon-box:before,
.ss-clock:before {
  content: '\e89e';
}

.icon-print:before {
  content: '\e837';
}

.icon-supercard-digital:before {
  content: '\E838';
}

.icon-supercard-login:before {
  content: '\E837';
}

.icon-block:before,
.ss-ban:before {
  content: '\e828';
}

.icon-settings:before,
.ss-settings:before {
  content: '\e829';
}

.icon-ic-shoppingbag-filled:before {
  content: '\e83f';
}

.svg-container {
  display: block;
  overflow: hidden;

  &.size-49 {
    width: 49px;
    height: 49px;
  }

  &.size-29 {
    width: 29px;
    height: 29px;
  }

  &.size-16 {
    width: 16px;
    height: 16px;

    &.lg-size-18 {
      @media (min-width: 922px) {
        width: 18px;
        height: 18px;
      }
    }
  }

  &.size-14 {
    width: 14px;
    height: 14px;

    &.lg-size-16 {
      @media (min-width: 922px) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &.size-14 {
    width: 14px;
    height: 14px;

    &.lg-size-16 {
      @media (min-width: 922px) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &.size-12 {
    width: 12px;
    height: 12px;

    &.lg-size-14 {
      @media (min-width: 922px) {
        width: 14px;
        height: 14px;
      }
    }
  }

  &.size-10 {
    width: 10px;
    height: 10px;

    &.lg-size-12 {
      @media (min-width: 922px) {
        width: 12px;
        height: 12px;
      }
    }
  }

  &.size-8 {
    width: 8px;
    height: 8px;

    &.lg-size-10 {
      @media (min-width: 922px) {
        width: 10px;
        height: 10px;
      }
    }
  }

  &.size-6 {
    width: 6px;
    height: 6px;

    &.lg-size-8 {
      @media (min-width: 922px) {
        width: 8px;
        height: 8px;
      }
    }
  }
}